var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, set } from '@ember/object';
import { readOnly, or } from '@ember/object/computed';
import BillingInstrument from '@square/dashboard-data/models/billing/instrument';
import ExpirationDate from '@square/dashboard-data/models/squareup/simple-instrument-store/api/expiration-date';
import { Type } from '@square/dashboard-data/models/squareup/simple-instrument-store/api/instrument';
import UnencryptedCardInformation from '@square/dashboard-data/models/squareup/simple-instrument-store/api/unencrypted-card-information';
import { v4 as uuid } from 'uuid';
import { CardInformation, CardLinkingEntryMethod } from '@square/dashboard-data/models/squareup/simple-instrument-store/api/verify-and-link-instrument-request';
import { Entity } from '@square/dashboard-data/models/squareup/simple-instrument-store/api/entity';
// eslint-disable-next-line import/named
import { CardUtils } from 'field-kit';
import { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import InstrumentsOnFile, { EntityTokenType } from '@square/dashboard-data/models/squareup/rolodex/instruments-on-file';
import Product from '@square/dashboard-data/models/squareup/simple-instrument-store/api/product';
function newCardInformation() {
  return CardInformation.create({
    entryMethod: CardLinkingEntryMethod.KEYED,
    unencryptedCardInformation: UnencryptedCardInformation.create({
      expirationDate: ExpirationDate.create()
    })
  });
}
let card = (_dec = attr('proto-base-model', {
  modelClass: CardInformation,
  embedded: true,
  defaultValue: () => newCardInformation()
}), _dec2 = attr('proto-base-model', {
  modelClass: Type,
  embedded: true,
  defaultValue: Type.CARD
}), _dec3 = attr('string'), _dec4 = attr('proto-base-model', {
  modelClass: Entity,
  embedded: true
}), _dec5 = attr('enum', {
  enumClass: EntityTokenType,
  defaultValue: EntityTokenType.WEB_MERCHANT
}), _dec6 = attr('enum', {
  enumClass: Product,
  defaultValue: Product.MERCHANT_BILLING
}), _dec7 = attr('proto-base-model', {
  modelClass: InstrumentsOnFile,
  embedded: true
}), _dec8 = readOnly('cardInformation.unencryptedCardInformation.expirationDate.validAndNotExpired'), _dec9 = computed('cardInformation.pan', function () {
  const bin = this.cardInformation?.pan.slice(0, 6);
  const brand = CardUtils.determineCardType(bin);
  if (brand) {
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  } else {
    return 'card';
  }
}), _dec10 = computed('brand', 'cardInformation.expirationDate.{twoDigitMonth,twoDigitYear}', 'cardInformation.{cardholderName,pan,postalCode,securityCode}', 'store', function () {
  return this.store.createFragment('subscription-card', {
    pan: this.cardInformation?.pan,
    type: this.brand,
    lastFour: this.cardInformation?.pan.slice(-4),
    expirationMonth: this.cardInformation?.expirationDate?.twoDigitMonth,
    expirationYear: this.cardInformation?.expirationDate?.twoDigitYear,
    securityCode: this.cardInformation?.securityCode,
    postalCode: this.cardInformation?.postalCode,
    cardholderName: this.cardInformation?.cardholderName
  });
}), _dec11 = or('_dirtyAttributes.length', 'cardInformation.isDirty'), _class = (_class2 = class card extends BillingInstrument {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "cardInformation", _descriptor2, this);
    _initializerDefineProperty(this, "type", _descriptor3, this);
    _initializerDefineProperty(this, "accountOwnerMerchantToken", _descriptor4, this);
    _initializerDefineProperty(this, "initiatingEntity", _descriptor5, this);
    _initializerDefineProperty(this, "owningEntityTokenType", _descriptor6, this);
    _initializerDefineProperty(this, "product", _descriptor7, this);
    // For dispaly Card-On-File
    _initializerDefineProperty(this, "instrument", _descriptor8, this);
    _initializerDefineProperty(this, "validExpirationDate", _descriptor9, this);
    _initializerDefineProperty(this, "brand", _descriptor10, this);
    _initializerDefineProperty(this, "asSubscriptionCard", _descriptor11, this);
    _initializerDefineProperty(this, "isDirty", _descriptor12, this);
  }
  toVerifyAndLinkInstrumentParams() {
    const params = {
      uniqueKey: uuid(),
      product: this.product,
      accountOwnerMerchantToken: this.accountOwnerMerchantToken,
      owningEntityToken: this.owningEntityToken,
      owningEntityTokenType: this.owningEntityTokenType
    };
    if (this.initiatingEntity) {
      params.initiatingEntity = this.initiatingEntity;
    }
    return this.cardInformation.encrypt().then(encryptedCardInformation => {
      params.cardInformation = encryptedCardInformation;
      return params;
    }).catch(() => {
      params.cardInformation = this.cardInformation;
      return params;
    });
  }
  reset() {
    set(this, 'cardInformation', newCardInformation());
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'billing/card'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cardInformation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "accountOwnerMerchantToken", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "initiatingEntity", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "owningEntityTokenType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "product", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "instrument", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "validExpirationDate", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "brand", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "asSubscriptionCard", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { card as default };